import React from 'react'

const Toptext = ({ icon, children ,variant="black"}) => {
  return (
    <div className='flex max-w-[90%] sm:max-w-full bg-jbsBlue/10 px-8 py-1 rounded-full items-center text-center justify-center gap-2'>
      {icon && <img src={icon} alt="icon" className={`w-6 h-6 ${variant === "white" ? "invert" : ""}`} />}
      <p className={`text-xs sm:text-base md:text-[15px] lg:text-[16px] xl:text-[17px] text-center font-medium ${variant === "white" ? "text-white" : "text-jbsBlue"}`}>
        {children}
      </p>
    </div>
  )
}

export default Toptext
